import ModalWindow from "components/ModalWindow";
import useProfile from "hooks/useProfile";
import icon from "assets/img/icons/icon-warning.svg";
import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";

const MultipleListingPopupFail = ({ close }) => {
  const { errorText } = useProfile();

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={close} />
        <header className="modal-window__header">
          <img src={icon} className="modal-window__icon" alt="" />
          <h5 className="modal-window__title">Fail</h5>
          <p className="modal-window__info">{errorText}</p>
        </header>
        <footer className="modal-window__footer">
          <button className="modal-window__footer-close" onClick={close}>
            Close
          </button>
        </footer>
      </div>
    </ModalWindow>
  );
};

export default MultipleListingPopupFail;
